import { useSelector } from "react-redux";

const useReceiverHubStations = () => {
  const { allLocations } = useSelector((state) => state.locations);
  const { userDetails } = useSelector((state) => state.loggedInUser);

  const hubs = allLocations
    .filter((item) => userDetails.hubs.includes(+item.id))
    .map((location) => ({
      id: location.id,
      value: location.name,
    }));

  return hubs?.length ? hubs : [];
};

export default useReceiverHubStations;
